import React, {lazy, Suspense} from 'react';
import {LoadingSpinner} from '@albert-io/atomic';

import {toCoordsList} from './entities/entities.utils';
import {flavorTypes, colors, entityTypeNames} from './constants';

import './graphing-input.scss';

const BoardWrapper = lazy(() => import('./BoardWrapper.react'));

const modes = {
  editing: 'editing', // All entities are selectable and editable.
  guessing: 'guessing', // Only studentGuess
  reviewing: 'reviewing'
};

interface Props {
  id: string;
  attributes?: object;
  initialEntities?: object[];
  [key: string]: unknown;
}

export default function GraphingInput({id, ...rest}: Props) {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <BoardWrapper key={id} id={id} {...rest} />
    </Suspense>
  );
}

export {modes, colors, flavorTypes, entityTypeNames, toCoordsList};
